import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';
import store from '../store';
import { getToken } from '@/commons/utils';
Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
    routes
});
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err);
};

router.beforeEach((to, from, next) => {
    if (to.meta && to.meta.title) {
        document.title = to.meta.title;
    } else {
        document.title = '开放平台-门户';
    }
    if (to.path === '/login' && getToken()) {
        next('/');
    } else if (
        (to.matched || []).some(v => v.meta && v.meta.auth) &&
        !getToken()
    ) {
        store.dispatch('sys/logout');
        next();
    } else {
        next();
    }
});

export default router;
